export type ComponentController<T1> = (props: T1) => React.ReactNode;

const useComponentController = <T1, T2>(
  hook: (p: T1) => T2,
  view: (p: T2) => React.ReactNode,
): ComponentController<T1> => {
  return (props) => {
    return view(hook(props));
  };
};

export { useComponentController };
